import { IonContent, IonPage } from '@ionic/react';

import { AppHeader, CollapsibleHeading, Section } from '@/components/Common';
import { Stack } from '@/components/Elements';
import { Text } from '@/components/Typography';

import { UpgradableTicket } from '../components/UpgradableTicket';

const PASS_STACK_VERTICAL_SPACING = '2.5x';

export const UpgradableTickets = () => {
  const renderTickets = () => {
    return (
      <Section>
        <Stack marginTop="1x" space={PASS_STACK_VERTICAL_SPACING}>
          {[...Array(10)].map((id) => (
            <UpgradableTicket key={id} />
          ))}
        </Stack>
      </Section>
    );
  };

  return (
    <IonPage id="ticket-upgrade-main-page">
      <AppHeader title="Select Ticket"></AppHeader>

      <IonContent className="ion-padding" fullscreen>
        <CollapsibleHeading title="Select Ticket"></CollapsibleHeading>
        <Text>You have 10 tickets eligible for upgrade</Text>
        {renderTickets()}
      </IonContent>
    </IonPage>
  );
};
